angular
    .module('app')
    .component('badgesAdd', {
        templateUrl: '/templates/pages/badges/badgesAdd/badgesAdd.html',
        controller: 'BadgesAddController',
        controllerAs: 'vm',
    });